import React from 'react';

export interface PanelSectionWrapperProps {
  title: string;
}
export const PanelSectionWrapper: React.FC<
  React.PropsWithChildren<PanelSectionWrapperProps>
> = ({ title, children }) => {
  return (
    <div className="px-4 pt-4">
      <div className="text-sm text-gray-500 mb-2">{title}</div>
      <div className={'flex flex-col gap-4'}>{children}</div>
    </div>
  );
};
